declare global {
	interface Window {
		onYouTubeIframeAPIReady: () => void;
	}
}

class YoutubeService {
	loaded: boolean = false;
	#items: {
		iframe: HTMLIFrameElement;
		promise: Promise<YT.Player>;
		resolve: (value: YT.Player) => void;
	}[] = [];

	register = (iframe: HTMLIFrameElement): Promise<YT.Player> => {
		const item = this.#items.find((item) => item.iframe === iframe);

		if (this.#items.length === 0) {
			this.#initYoutubeAPI();
		}

		if (item) {
			return item.promise;
		}

		let promiseResolve: (value: YT.Player) => void;
		const promise = new Promise<YT.Player>((resolve) => {
			promiseResolve = resolve;
			if (this.loaded && YT) {
				new YT.Player(iframe, {
					events: {
						onReady: (event) => {
							resolve(event.target);
						},
					},
				});
			}
		});

		this.#items.push({
			iframe: iframe,
			promise: promise,
			resolve: promiseResolve,
		});

		return promise;
	};

	#initYoutubeAPI = (): void => {
		const scriptTag = document.createElement("script");
		scriptTag.src = "https://www.youtube.com/iframe_api";
		document.head.append(scriptTag);

		window.onYouTubeIframeAPIReady = () => {
			this.loaded = true;

			this.#items.forEach(({ iframe, resolve }) => {
				new YT.Player(iframe, {
					events: {
						onReady: (event) => {
							resolve(event.target);
						},
					},
				});
			});
		};
	};
}

export const youtubeService = new YoutubeService();
